const i18nCards = {
  "section.latest.title": "Your latest session",
  "section.training.skill.radar": "Skill radar",
  "section.training.streak.title": "Training streak",
  "section.overall.progress.title": "Overall progress",
  "section.overall.progress.chart.title": "Past year",
  "section.overall.progress.chart.no.data": "No data available",
  "section.metric.progress.title": "Metric progress",
  "card.training.streak.title": "Weekly goal",
  "card.skill.level.title": "Current performance",
  "card.results-chart.all": "Overall performance",
  "card.results-chart.critical_scan": "Critical scan",
  "card.results-chart.scan_frequency": "Scan rate",
  "card.results-chart.scan_timing": "Scan timing",
  "card.results-chart.awareness": "Awareness",
  "card.results-chart.decision": "Decision",
  "card.results-chart.no.data": "No data available",
};

export default i18nCards;
